import { render, staticRenderFns } from "./TableItemActions.vue?vue&type=template&id=9a9df834&scoped=true&"
import script from "./TableItemActions.vue?vue&type=script&lang=js&"
export * from "./TableItemActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9df834",
  null
  
)

export default component.exports